import type { Exact, Scalars } from 'codegen/src/gateway/types'

export type FindTotalItemsByUserQueryVariables = Exact<{
	channel: Scalars['String']['input']
	countryIso3166_2: Scalars['String']['input']
}>

export type FindTotalItemsByUserQuery = {
	findTotalItemsByUser?: { totalItems: number } | null
}

export const FindTotalItemsByUserDocument = `
    query FindTotalItemsByUser($channel: String!, $countryIso3166_2: String!) {
  findTotalItemsByUser(channel: $channel, countryIso3166_2: $countryIso3166_2) {
    totalItems
  }
}
    `
